/**
 * Bajo los filtros, cuando se busca texto y el filtro Estado está en «Abiertas»: avisa si la búsqueda
 * también coincide con tareas cerradas (que no se ven), con un botón por tarea que la abre. Evita crear
 * de nuevo algo que ya se hizo o se descartó. Usa los mismos filtros, pidiendo solo las cerradas.
 */
import { formatearNumero } from '@cdtec-backlog/contrato';
import type { FiltrosUI } from './api';
import { useTareas } from './hooks';
import { EstadoTarea } from './MarcaCierre';
import './AvisoCerradas.css';

/** Botones que se muestran como máximo; el resto se resume en «y N más». */
const MAX_BOTONES = 8;

export function AvisoCerradas({
  filtros,
  onAbrir,
}: {
  filtros: FiltrosUI;
  onAbrir: (id: number) => void;
}) {
  const activo = filtros.texto.trim() !== '' && filtros.estado === 'abiertas';
  const cerradas = useTareas({ ...filtros, estado: 'cerradas' }, { activo });
  if (!activo || !cerradas.data || cerradas.data.total === 0) return null;

  const { items, total } = cerradas.data;
  const visibles = items.slice(0, MAX_BOTONES);
  return (
    <div className="aviso-cerradas" role="status">
      <span>
        {total === 1
          ? 'También coincide una tarea cerrada:'
          : `También coinciden ${total} tareas cerradas:`}
      </span>
      {visibles.map((tarea) => (
        <button
          key={tarea.id}
          type="button"
          title={tarea.titulo}
          aria-label={`Abrir ${formatearNumero(tarea.numero)}: ${tarea.titulo}`}
          onClick={() => onAbrir(tarea.id)}
        >
          {formatearNumero(tarea.numero)} ·
          <EstadoTarea estado={tarea.estado} />
        </button>
      ))}
      {total > visibles.length && <span>y {total - visibles.length} más</span>}
    </div>
  );
}
